const API_URL = process.env.REACT_APP_SERVER_URL + '/api';

export const searchAPI = async (requestBody, file = null) => {
    let response;
    
    if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('data', JSON.stringify(requestBody));
        
        response = await fetch(`${API_URL}/search`, {
        method: 'POST',
        body: formData
        });
    } else {
        response = await fetch(`${API_URL}/search`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
        });
    }

    if (!response.ok) {
        throw new Error('Search failed');
    }
    const reply = await response.json();
    return reply;
};
